import { gql } from "@apollo/client";
import { RHTVPageFieldsFragment } from "@/fragments/RockHallTv";

export const Page = gql`
  ${RHTVPageFieldsFragment}
  query RHTVPage($databaseId: ID!, $asPreview: Boolean = false, $language: String = "en") {
    rhPage(id: $databaseId, asPreview: $asPreview, language: $language) {
      ...RhtvPageFields
    }
  }
`;
